import gql from 'graphql-tag';

export default gql`
  mutation submitXFormAnswer(
    $formAnswerXuid: String!
    $state: String!
  ) {
    submitXFormAnswer(
      formAnswerXuid: $formAnswerXuid
      state: $state
    ) {
      xuid
      flowState
      formXuid
      updatedAt
    }
  }
`;
